<template>
  <div v-if="!loading && details" class="row">
    <div class="col-12 col-lg-4 mb-5">
      <div class="row">
        <div class="col">
          <strong># {{ $t('default.evaluations.student') }}</strong>
        </div>
      </div>
      
      <div class="row my-2" :key="student.studentID" v-for="(student, $sIdx) of details.evaluations">
         
        <div class="col-12 col-md-6 col-lg-7">
          {{ $sIdx + 1 }}
          {{ $helpers.getLocalizedField(student, 'stud') }} 
        </div>
        <div class="col-12 col-md-6 col-lg-5">
          <div class="row">
           
            <div :key="$eIdx" v-for="(evaluation, $eIdx) of student.evaluation" class="col-6">

              <div v-if="hasUploaded($sIdx, 'წერითი') && hasUploaded($sIdx, evaluation.category)" class="input-group mb-3">
                <input class="form-control"
                       @blur="handleInput($sIdx, $eIdx)"
                       v-model="evaluation.point"
                       type="text" />
                <div class="input-group-append">
                  <img @click="handleFileClick($sIdx, evaluation.category)" class="c-pointer file-icon"
                       :src="getFileIcon(evaluation.category)">
                </div>
              </div>
            </div>
<!--            <div v-if="student.ppt" class="col-6">-->
<!--              <div class="input-group mb-3">-->
<!--                <input class="form-control"-->
<!--                       @keypress.enter="handleInput($sIdx)"-->
<!--                       v-model="student.evaluation[0].point"-->
<!--                       type="text" />-->
<!--                <div class="input-group-append">-->
<!--                  <img @click="openFile = student.ppt" class="c-pointer file-icon" src="https://files.ug.edu.ge/online.ug.edu.ge/images/powerpointIcon.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="student.doc" class="col-6">-->
<!--              <div class="input-group mb-3">-->
<!--                <input class="form-control"-->
<!--                       @keypress.enter="handleInput($sIdx)"-->
<!--                       v-model="student.evaluation[1].point"-->
<!--                       type="text" />-->
<!--                <div class="input-group-append">-->
<!--                  <img @click="openFile = student.doc" class="c-pointer file-icon" src="https://files.ug.edu.ge/online.ug.edu.ge/images/wordIcon.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    
    

    <div  class="col-12 col-lg-8 mb-5">

      <iframe id="iframeID" style="width: 100%; height: 100%;" src=""></iframe>

    </div>


  </div>
</template>
<script>
import mammoth from 'mammoth';
import pptx2html from "pptx2html"
import EvaluationResource from '../../api/evaluationResource'
const evaluationResource = new EvaluationResource()
export default {
  name: 'GroupPresentationEvaluations',

  props: ['loading', 'details'],

  data () {
    return {
      openFile: null,
      mime:null,
      isLoading: false, // to show the loading message
      docxContent: "", // to store the converted HTML content
      fileExtension:null
    }
  },

 mounted(){

  document.getElementById('iframeID').setAttribute('src',"")

 },

  methods: {
    hasUploaded (sIdx, category) {

         


      if (category === 'წერითი' || category === 'რეფერატი' || category === 'ზეპირი'  || category === 'პრეზენტაცია' || category === 'პრაქტიკული' || category ==='პროექტი') return this.details.evaluations[sIdx].doc != null
 

      return false
    },

    getFileIcon (type) {
      if (type === 'წერითი' || type === 'რეფერატი' || type ==='პროექტის მომზადება' || type ==='პროექტი') return 'https://files.ug.edu.ge/online.ug.edu.ge/images/wordIcon.png'
      if (type === 'ზეპირი' | type === 'პრეზენტაცია' || type === 'პრაქტიკული') return 'https://files.ug.edu.ge/online.ug.edu.ge/images/powerpointIcon.png'

      return null
    },

    saveEvaluation (sIdx, eIdx) {
      this.$emit('save-evaluation', {
        type: 'presentation',
        studentId: this.details.evaluations[sIdx].studentID,
        rateComponentId: this.details.evaluations[sIdx].evaluation[eIdx].id,
        point: this.details.evaluations[sIdx].evaluation[eIdx].point
      })
    },

    handleFileClick (sIdx, category) {
     
      if (category === 'წერითი' || category === 'რეფერატი' || category ==='პროექტის მომზადება' || category ==='პროექტი') {
        this.openFile = this.details.evaluations[sIdx].doc

        this.mime=this.details.evaluations[sIdx].docMime
        this.fileExtension=this.details.evaluations[sIdx].doc.split('.').pop()
      } else if (category === 'ზეპირი' || category === 'პრეზენტაცია' || category === 'პრაქტიკული') {
        this.openFile = this.details.evaluations[sIdx].ppt
        this.mime=this.details.evaluations[sIdx].pptMime
        this.fileExtension=this.details.evaluations[sIdx].ppt.split('.').pop()
      }

      this.isLoading=true
      evaluationResource.getPresentationFileLink(this.openFile).then(response=>{

          if(this.openFile.split('.').pop()=='pdf'){
            document.getElementById('iframeID').setAttribute('src',response.data)
          }else {

               document.getElementById('iframeID').setAttribute('src','https://view.officeapps.live.com/op/embed.aspx?src='+response.data+'&embedded=true')
          }

      })

        



    },

    handleInput (sIdx, eIdx, event) {
      this.saveEvaluation(sIdx, eIdx)
    }
  }
}
</script>
<style scoped>
.file-view {
  width: 100%;
  height: 100%
}

.file-icon {
  max-width: 30px;
  border-top-right-radius: 70px;
  border-bottom-right-radius: 70px;
}
</style>
